import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "box has-background-grey-dark" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "table is-hoverable is-fullwidth" }
const _hoisted_4 = {
  key: 0,
  colspan: "4"
}
const _hoisted_5 = ["data-tooltip"]
const _hoisted_6 = ["data-tooltip"]
const _hoisted_7 = ["data-tooltip"]
const _hoisted_8 = ["data-tooltip"]
const _hoisted_9 = { key: 4 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "icon trash" }
const _hoisted_12 = { class: "columns" }
const _hoisted_13 = { class: "column is-12" }
const _hoisted_14 = { class: "s-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_ApexChart = _resolveComponent("ApexChart")!
  const _component_VModal = _resolveComponent("VModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title-wrap" }, [
      _createElementVNode("h1", { class: "title mb-1" }, "Custom")
    ], -1)),
    _createVNode(_component_Timestamp, { "timestamp-data": _ctx.timestampData }, null, 8, ["timestamp-data"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { scope: "col" }, "Strategy"),
            _createElementVNode("th", { scope: "col" }, "Mid"),
            _createElementVNode("th", { scope: "col" }, "Change"),
            _createElementVNode("th", { scope: "col" }, "5PM Close"),
            _createElementVNode("th", { scope: "col" }, "Chart")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (_ctx.timestampData === 'Loading...')
              ? (_openBlock(), _createElementBlock("td", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "container-load" }, [
                    _createElementVNode("i", { class: "fas fa-circle-notch fa-spin fa-5x" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridData, (entry) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: entry['Strategy']
            }, [
              (entry['Strategy'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: _normalizeClass({ strat_up: (entry['a_status'] == 'a_up'), strat_down: (entry['a_status'] == 'a_down')}),
                    "data-tooltip": entry['strat_legs'].substring(0,20)
                  }, _toDisplayString(entry['Strategy'].substring(entry['Strategy'].length, entry['Strategy'].indexOf('-') != -1 ? entry['Strategy'].indexOf('-') : 0).replace('-', '')), 11, _hoisted_5))
                : _createCommentVNode("", true),
              (entry['Mid'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 1,
                    "data-tooltip": entry['strat_legs'],
                    class: "mid"
                  }, _toDisplayString(entry['Mid']), 9, _hoisted_6))
                : _createCommentVNode("", true),
              (entry['Change'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 2,
                    class: _normalizeClass({ inc_a : (entry['a_status'] == 'a_up') , dec_a: (entry['a_status'] == 'a_down') }),
                    "data-tooltip": entry['strat_legs'].substring(0,20)
                  }, [
                    _createTextVNode(_toDisplayString(entry['Change']) + " ", 1),
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "arrow" }, null, -1))
                  ], 10, _hoisted_7))
                : _createCommentVNode("", true),
              (entry['3PM Close'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 3,
                    "data-tooltip": entry['strat_legs'].substring(0,20)
                  }, _toDisplayString(entry['3PM Close']), 9, _hoisted_8))
                : _createCommentVNode("", true),
              (entry['chart'])
                ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                    (entry['chart']===true)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.getChartData(entry['Strategy']), _ctx.modalChart = true),
                          class: "chart-link"
                        }, [
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_component_VModal, {
                              open: _ctx.modalChart,
                              title: 'Chart for strategy '+this.stratNameChart,
                              actions: "center",
                              size: "big",
                              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalChart = false))
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(_component_ApexChart, {
                                        id: "apex-chart-1",
                                        height: _ctx.chart_options.chart.height,
                                        options: _ctx.chart_options,
                                        series: _ctx.chart_options.series,
                                        type: _ctx.chart_options.chart.type
                                      }, null, 8, ["height", "options", "series", "type"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["open", "title"]),
                            _cache[3] || (_cache[3] = _createElementVNode("i", {
                              "aria-hidden": "true",
                              class: "fa fa-chart-line"
                            }, null, -1))
                          ])
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}